function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { StyleSheet, color, font } from "../../../../styles/theme";
export var PAGINATION_HEIGHT = 49;
export var TOOLBAR_HEIGHT = 46;
export var TOOLBAR_DROPDOWN_LINE_HEIGHT = '44px';
export var SMALL_TOOL_WIDTH = 48;
export var TOOL_MARGIN = 12;
export var focusedStyle = {
  border: "1px solid ".concat(color.primary)
};
export default StyleSheet.create({
  focused: focusedStyle,
  noResultCell: {
    textAlign: 'center'
  },
  toolbar: {
    display: 'flex',
    flexWrap: 'nowrap',
    height: TOOLBAR_HEIGHT
  },
  searchBarWrapper: {
    height: TOOLBAR_HEIGHT,
    display: 'flex',
    flex: 1,
    border: "1px solid ".concat(color.divider),
    cursor: 'text'
  },
  searchBarInput: {
    'flex': 1,
    'margin': '9px 0',
    'lineHeight': '24px',
    'border': 'none',
    'fontSize': font.sm,
    ':focus': {
      outline: 'none'
    },
    '::placeholder': {
      color: color.secondaryText,
      opacity: 1
    }
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  searchBarIconWrapper: {
    height: '44px',
    margin: '0 12px'
  },
  dropdownWrapper: {
    marginLeft: TOOL_MARGIN
  },
  dropdownValue: {
    lineHeight: TOOLBAR_DROPDOWN_LINE_HEIGHT
  },
  dropdownPlaceholder: {
    lineHeight: TOOLBAR_DROPDOWN_LINE_HEIGHT,
    color: color.secondaryText
  },
  selectAllWrapper: {
    minWidth: SMALL_TOOL_WIDTH
  },
  actionButtonMargin: {
    marginRight: TOOL_MARGIN
  }
});
export var dropdownSelectStyle = _defineProperty(_defineProperty({
  border: 'none',
  borderRadius: 0,
  fontSize: font.sm,
  boxShadow: 'none',
  cursor: 'pointer'
}, "border", "1px solid ".concat(color.divider)), "height", TOOLBAR_HEIGHT);
export var dropdownOption = {
  lineHeight: '34px',
  padding: '6px 10px',
  fontSize: font.sm,
  cursor: 'pointer'
};
export var dropdownOptionFocused = {
  color: color.white,
  backgroundColor: color.primary
};
export var menuContainerStyle = _objectSpread(_objectSpread({}, focusedStyle), {}, {
  borderRadius: '0'
});
export var actionButtonStyle = {
  height: TOOLBAR_HEIGHT
};
export var iconActionButtonStyle = _objectSpread(_objectSpread({}, actionButtonStyle), {}, {
  width: SMALL_TOOL_WIDTH,
  border: 'none'
});
export var svgProps = {
  size: 20,
  hoverColor: color.primary
};
export var disabledSvgProps = {
  color: color.lightGrayText,
  hoverColor: color.lightGrayText
};
export var disabledButtonStyle = {
  backgroundColor: 'transparent'
};